import { Container } from 'unstated';
import { getPersistentStore, getPersistentStoreMutex } from '@lemonadefashion/storage';

const KEY = 'last_time_logo_animation_played';
function _getStore() { return getPersistentStore(); }
function _getMutex() { return getPersistentStoreMutex(); }

function getLastTimeLogoAnimationPlayedFromStore() {
  try {
    const infoJson = _getStore().getItem(KEY);
    if (infoJson == null) return null;
    return JSON.parse(infoJson);
  } catch (error) {
    console.log(error);
    return null;
  }
}

function bumpLastTimeLogoAnimationPlayedInStore() {
  return new Promise((resolve, reject) => {
    const mutex = _getMutex();
    const store = _getStore();
    mutex.lock(KEY)
      .then(() => {
        store.setItem(KEY, JSON.stringify(Date.now() / 1000));
        return mutex.release(KEY).then(resolve).catch(reject);
      })
      .catch(reject);
  });
}

class LastTimeLogoAnimationPlayedContainer extends Container {
  constructor() {
    super();
    this.state = {
      lastTimeLogoAnimationPlayed: getLastTimeLogoAnimationPlayedFromStore()
    };
    window.addEventListener('storage', e => {
      if (e.key !== KEY) return;
      this.setState({ lastTimeLogoAnimationPlayed: getLastTimeLogoAnimationPlayedFromStore() });
    });
  }

  get() { return this.state.lastTimeLogoAnimationPlayed; }

  bump() {
    return new Promise((resolve, reject) => {
      bumpLastTimeLogoAnimationPlayedInStore()
        .catch(console.log)
        .finally(() => {
          this.setState({ lastTimeLogoAnimationPlayed: getLastTimeLogoAnimationPlayedFromStore() }, resolve);
        });
    });
  }
}

export default LastTimeLogoAnimationPlayedContainer;
